<template>
  <div v-if="loading" class="loading text-center">
    <b-spinner
      variant="primary"
      type="grow"
      :label="`${this.$t('reports.loadingLabel')}...`"
    ></b-spinner>
  </div>
  <div v-else>
    <div class="row mt-4">
      <div class="col-6 text-center">
        <p class="idx-bold">
          Relatório Mapa Mundi -
          {{
            this.myMetric.indexOf('nps') >= 0
              ? 'NPS'
              : this.myMetric.indexOf('ces') >= 0
              ? 'CES'
              : this.myMetric === 'csat-1-5'
              ? 'CSAT'
              : this.myMetric === 'csat-1-5(media)'
              ? 'CSAT (Média)'
              : this.myMetric === 'csat-0-10(media)'
              ? 'CSAT (Média)'
              : '5Stars'
          }}
        </p>
        <highcharts
          :constructor-type="'mapChart'"
          :options="chartOptions"
        ></highcharts>
      </div>
      <div class="col-6 table-area text-center">
        <b-table
          id="table-indicators"
          class="map-table"
          responsive
          striped
          :fields="fields"
          :items="answersByLocale"
          style="max-width: 500px;"
        >
          <template v-slot:cell(nps)="row">
            <span
              :style="`color: ${getNPSColor(row.item.nps)}; font-weight: bold`"
              >{{ row.item.nps }}</span
            >
            <!-- <radial-progress-bar
            :diameter="50"
            :stroke-width="5"
            innerStrokeColor="#f1f1f1"
            :startColor="getNPSColor(row.item.nps)"
            :stopColor="getNPSColor(row.item.nps)"
            :completed-steps="row.item.nps"
            :total-steps="100"
          >
            <animated-number
              :value="row.item.nps.toString()"
              :formatValue="formatToPrice"
              :duration="1000"
            />
            <b-tooltip target="number-nps" placement="bottom"> </b-tooltip>
          </radial-progress-bar> -->
          </template>
        </b-table>
      </div>
    </div>
    <div class="row">
      <div
        v-if="myMetric == 'nps-0-10' || myMetric == 'nps-1-5'"
        class="col-12 mt-5 subtitle-area"
      >
        <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
        <span class="nps-lt-0 legend-circle ml-2 mr-2" />
        <span>{{ this.$t('reports.mapChart.npslt0') }}</span>
        <span class="nps-0-49 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.npslt50') }}</span>
        <span class="nps-50-69 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.npslt70') }}</span>
        <span class="nps-70-79 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.npslt80') }}</span>
        <span class="nps-80-100 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.npsge80') }}</span>
      </div>
      <div v-else-if="myMetric === 'ces-1-5'" class="col-12 mt-5 subtitle-area">
        <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
        <span class="nps-lt-0 legend-circle ml-2 mr-2" />
        <span>{{ this.$t('reports.mapChart.ceslt2') }}</span>
        <span class="nps-0-49 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.ceslt3') }}</span>
        <span class="nps-50-69 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.ceslt4') }}</span>
        <span class="nps-70-79 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.ceslt5') }}</span>
        <span class="nps-80-100 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.cesge5') }}</span>
      </div>
      <div
        v-else-if="myMetric === 'csat-1-5' || myMetric === 'csat-1-5(media)'"
        class="col-12 mt-5 subtitle-area"
      >
        <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
        <span class="nps-lt-0 legend-circle ml-2 mr-2" />
        <span>CSAT 0</span>
        <span class="nps-0-49 legend-circle ml-3 mr-2" />
        <span>CSAT 0 - 49</span>
        <span class="nps-50-69 legend-circle ml-3 mr-2" />
        <span>CSAT 50 - 69</span>
        <span class="nps-70-79 legend-circle ml-3 mr-2" />
        <span>CSAT 70 - 79</span>
        <span class="nps-80-100 legend-circle ml-3 mr-2" />
        <span>CSAT 80 - 100</span>
      </div>
      <div v-else-if="myMetric === '5-stars'" class="col-12 mt-5 subtitle-area">
        <strong>{{ this.$t('reports.mapChart.subtitleLabel') }}: </strong>
        <span class="nps-lt-0 legend-circle ml-2 mr-2" />
        <span>{{ this.$t('reports.mapChart.fiveStarslt2') }}</span>
        <span class="nps-0-49 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.fiveStarslt3') }}</span>
        <span class="nps-50-69 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.fiveStarslt4') }}</span>
        <span class="nps-70-79 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.fiveStarslt5') }}</span>
        <span class="nps-80-100 legend-circle ml-3 mr-2" />
        <span>{{ this.$t('reports.mapChart.fiveStarsge5') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Highcharts from 'highcharts';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import mapInit from 'highcharts/modules/map';
import mapData from './world-eckert3-highres.geo.json';

mapInit(Highcharts);

const locales = [
  'AFG',
  'ZAF',
  'ALB',
  'DEU',
  'AND',
  'AGO',
  'AIA',
  'ATA',
  'ATG',
  'ANT',
  'SAU',
  'DZA',
  'ARG',
  'ARM',
  'ABW',
  'AUS',
  'AUT',
  'AZE',
  'BHS',
  'BHR',
  'BGD',
  'BRB',
  'BLR',
  'BEL',
  'BLZ',
  'BEN',
  'BMU',
  'BOL',
  'BIH',
  'BWA',
  'BRA',
  'BRN',
  'BGR',
  'BFA',
  'BDI',
  'BTN',
  'CPV',
  'CMR',
  'KHM',
  'CAN',
  'KAZ',
  'TCD',
  'CHL',
  'CHN',
  'CYP',
  'SGP',
  'COL',
  'COG',
  'PRK',
  'KOR',
  'CIV',
  'CRI',
  'HRV',
  'CUB',
  'DNK',
  'DJI',
  'DMA',
  'EGY',
  'SLV',
  'ARE',
  'ECU',
  'ERI',
  'SVK',
  'SVN',
  'ESP',
  'USA',
  'EST',
  'ETH',
  'FJI',
  'PHL',
  'FIN',
  'FRA',
  'GAB',
  'GMB',
  'GHA',
  'GEO',
  'GIB',
  'GBR',
  'GRD',
  'GRC',
  'GRL',
  'GLP',
  'GUM',
  'GTM',
  'GGY',
  'GUY',
  'GUF',
  'GIN',
  'GNQ',
  'GNB',
  'HTI',
  'NLD',
  'HND',
  'HKG',
  'HUN',
  'YEM',
  'BVT',
  'IMN',
  'CXR',
  'PCN',
  'REU',
  'ALA',
  'CYM',
  'CCK',
  'COM',
  'COK',
  'FRO',
  'FLK',
  'SGS',
  'HMD',
  'MNP',
  'MHL',
  'UMI',
  'NFK',
  'SYC',
  'SLB',
  'SJM',
  'TKL',
  'TCA',
  'VIR',
  'VGB',
  'WLF',
  'IND',
  'IDN',
  'IRN',
  'IRQ',
  'IRL',
  'ISL',
  'ISR',
  'ITA',
  'JAM',
  'JPN',
  'JEY',
  'JOR',
  'KEN',
  'KIR',
  'KWT',
  'LAO',
  'LVA',
  'LSO',
  'LBN',
  'LBR',
  'LBY',
  'LIE',
  'LTU',
  'LUX',
  'MAC',
  'MKD',
  'MDG',
  'MYS',
  'MWI',
  'MDV',
  'MLI',
  'MLT',
  'MAR',
  'MTQ',
  'MUS',
  'MRT',
  'MYT',
  'MEX',
  'FSM',
  'MOZ',
  'MDA',
  'MCO',
  'MNG',
  'MNE',
  'MSR',
  'MMR',
  'NAM',
  'NRU',
  'NPL',
  'NIC',
  'NER',
  'NGA',
  'NIU',
  'NOR',
  'NCL',
  'NZL',
  'OMN',
  'PLW',
  'PAN',
  'PNG',
  'PAK',
  'PRY',
  'PER',
  'PYF',
  'POL',
  'PRI',
  'PRT',
  'QAT',
  'KGZ',
  'CAF',
  'COD',
  'DOM',
  'CZE',
  'ROM',
  'RWA',
  'RUS',
  'ESH',
  'VCT',
  'ASM',
  'WSM',
  'SMR',
  'SHN',
  'LCA',
  'BLM',
  'KNA',
  'MAF',
  'STP',
  'SEN',
  'SLE',
  'SRB',
  'SYR',
  'SOM',
  'LKA',
  'SPM',
  'SWZ',
  'SDN',
  'SWE',
  'CHE',
  'SUR',
  'TJK',
  'THA',
  'TWN',
  'TZA',
  'IOT',
  'ATF',
  'PSE',
  'TMP',
  'TGO',
  'TON',
  'TTO',
  'TUN',
  'TKM',
  'TUR',
  'TUV',
  'UKR',
  'UGA',
  'URY',
  'UZB',
  'VUT',
  'VAT',
  'VEN',
  'VNM',
  'ZMB',
  'ZWE',
];

export default {
  components: {
    RadialProgressBar,
    animatedNumber,
  },

  data: () => ({
    loading: true,
    userAuth: null,
    chartOptions: {
      title: {
        text: '',
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: 'bottom',
        },
      },
      legend: {
        enabled: false,
      },
      chart: {
        height: 600,
      },
      colorAxis: {
        min: 0,
      },
      path: {
        stroke: 'white',
      },
      series: [
        {
          data: [],
          mapData,
          joinBy: ['iso-a3', 'code3'],
          name: 'NPS',
          nullColor: '#D8D8D8',
          borderColor: '#FFF',
          dataLabels: {
            enabled: true,
          },
        },
      ],
    },
    fields: [],
    answersByLocale: [],
  }),

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.changeLabel();
    await this.getNPSByLocale();
  },

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),

    answersByLocaleConverted() {
      const chartFormat = [];

      this.answersByLocale.forEach((el) => {
        chartFormat.push({
          code3: `${el.locale}`.toUpperCase(),
          value: el.nps,
          color: el.color,
        });
      });
      return chartFormat;
    },
  },

  watch: {
    actionGroupData: async function watchActionGroupData() {
      await this.getNPSByLocale();
    },
    myActionId: async function watchMyActionId() {
      await this.getNPSByLocale();
    },
    myActionsIds: async function watchMyActionsIds() {
      await this.getNPSByLocale();
    },
    myIh1: async function watchMyIh1() {
      await this.getNPSByLocale();
    },
    myHierarchies1: async function watchMyHierarchies1(){
      await this.getNPSByLocale();
    },
    myIh2: async function watchMyIh2() {
      await this.getNPSByLocale();
    },
    myHierarchies2: async function watchMyHierarchies2(){
      await this.getNPSByLocale();
    },
    calendarDates: async function watchDates() {
      await this.getNPSByLocale();
    },
    myMetric: async function watchMyMetric() {
      await this.getNPSByLocale();
      this.changeLabel();
    },
    'indicatorData.value': async function watchIndicatorData() {
      await this.getNPSByLocale();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getNPSByLocale();
    },
  },

  methods: {
    ...mapActions('charts', ['setMapChartMundi']),

    async getNPSByLocale() {
      this.loading = true;

      this.chartOptions.series[0].data = [];

      this.answersByLocale = await this.setMapChartMundi({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      // filters only valid locale

      const newAnswers = [];

      this.answersByLocale.forEach((answer) => {
        if (answer.locale) {
          answer.locale = answer.locale.trim().toUpperCase();

          if (locales.includes(answer.locale)) {
            newAnswers.push(answer);
          }
        }
      });

      this.answersByLocale = newAnswers;

      this.setNPSColorsToLocale(this.answersByLocale);

      this.chartOptions.series[0].data = this.answersByLocaleConverted;

      this.loading = false;
    },

    getNPSColor(nps) {
      let color = '';
      if (
        this.myMetric.indexOf('nps') !== -1 ||
        this.myMetric.indexOf('csat') !== -1
      ) {
        if (nps >= 80) {
          color = '#6bca6c';
        } else if (nps < 80 && nps >= 70) {
          color = '#9fd77a';
        } else if (nps < 70 && nps >= 50) {
          color = '#fbcf3f';
        } else if (nps < 50 && nps >= 0) {
          color = '#fa834f';
        } else if (nps < 0) {
          color = 'red';
        }
      } else if (
        this.myMetric.indexOf('ces') !== -1 ||
        this.myMetric.indexOf('stars')
      ) {
        if (nps >= 5) {
          color = '#6bca6c';
        } else if (nps < 5 && nps >= 4) {
          color = '#9fd77a';
        } else if (nps < 4 && nps >= 3) {
          color = '#fbcf3f';
        } else if (nps < 3 && nps >= 2) {
          color = '#fa834f';
        } else if (nps < 2) {
          color = 'red';
        }
      }

      return color;
    },

    setNPSColorsToLocale(answersByLocale) {
      answersByLocale.forEach((answers) => {
        answers.color = this.getNPSColor(answers.nps);
      });
    },

    formatToPrice(value) {
      if (
        this.myMetric.indexOf('nps') !== -1 ||
        this.myMetric.indexOf('csat') !== -1
      ) {
        return value.toFixed(0);
      }
      return value.toFixed(1);
    },

    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.fields = [
          {
            key: 'locale',
            label: this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: this.$t('reports.npsLabel'),
            sortable: true,
          },
        ];
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.fields = [
          {
            key: 'locale',
            label: this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: this.$t('reports.cesLabel'),
            sortable: true,
          },
        ];
      } else if (this.myMetric === 'csat-1-5') {
        this.fields = [
          {
            key: 'locale',
            label: this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: 'CSAT',
            sortable: true,
          },
        ];
      } else if (this.myMetric === 'csat-1-5(media)') {
        this.fields = [
          {
            key: 'locale',
            label: this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: 'CSAT (Média)',
            sortable: true,
          },
        ];
      } else if (this.myMetric.indexOf('stars') !== -1) {
        this.fields = [
          {
            key: 'locale',
            label: this.$t('reports.mapChart.localeLabel'),
            sortable: true,
          },
          {
            key: 'answers',
            label: this.$t('reports.answersLabel'),
            sortable: true,
          },
          {
            key: 'nps',
            label: '5Stars',
            sortable: true,
          },
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-area {
  display: flex;
  justify-content: center;
  max-height: 600px;
  overflow-y: auto;
}

.subtitle-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.legend-circle {
  min-height: 15px;
  min-width: 15px;
}

.nps-lt-0 {
  border-radius: 50%;
  background-color: #ff0000;
}

.nps-0-49 {
  border-radius: 50%;
  background-color: #fa834f;
}

.nps-50-69 {
  border-radius: 50%;
  background-color: #fbcf3f;
}

.nps-70-79 {
  border-radius: 50%;
  background-color: #9fd77a;
}

.nps-80-100 {
  border-radius: 50%;
  background-color: #6bca6c;
}
// .radial-progress-inner {
//   span {
//     font-size: 16px !important;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/map-mundi-chart/index.vue